<template>
	<div id="switch-button">
		<label v-if="title !== undefined" class="pl-0" v-html="title" />
		<div class="switch-button-control">
			<div v-if="before !== undefined" class="switch-button-label">
				<span>{{ before }}</span>
			</div>

			<div class="switch-button" :class="{ enabled: isEnabled }" :style="{'--color': colorIn}" @click="toggle">
				<div class="button" />
			</div>

			<div v-if="after !== undefined" class="switch-button-label">
				<span>{{ after }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    model: {
        prop: "isEnabled",
        event: "toggle",
    },
    props: {
        isEnabled: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            required: false,
            default: "#38414aeb"
        },
        before: {
            type: String,
            required: false,
            default: undefined
        },
        after: {
            type: String,
            required: false,
            default: undefined
        },
        title: {
            type: String,
            required: false,
            default: undefined
        },
        colorEnabled: {
            type: String,
            required: false,
            default: "#1abc9c"
        }
    },
    data() {
        return {
            colorIn: '#38414aeb'
        }
    },
    watch: {
        isEnabled: {
            handler: function (val, oldVal) {
                if (val) {
                    this.colorIn = this.colorEnabled
                } else {
                    this.colorIn = this.color
                }
            },
            deep: true
        }
    },
    methods: {
        toggle: function () {
            // #00a65a
            this.$emit("toggle", !this.isEnabled);

            if (this.colorEnabled && !this.isEnabled) {
                this.colorIn = this.colorEnabled
            } else {
                this.colorIn = this.color
            }
        },
    }
};
</script>

<style lang="scss">
.switch-button-control {
    display: flex;
    flex-direction: row;
    align-items: center;

    .switch-button {
        $switch-button-height: 1.6em;
        $switch-button-color: var(--color);
        $switch-button-border-thickness: 2px;
        $switch-transition: all 0.3s ease-in-out;
        $switch-is-rounded: true;

        height: $switch-button-height;
        width: calc(#{$switch-button-height} * 2);
        border: $switch-button-border-thickness solid $switch-button-color;
        box-shadow: inset 0px 0px $switch-button-border-thickness 0px rgba(0, 0, 0, 0.33);
        border-radius: if($switch-is-rounded, $switch-button-height, 0);

        transition: $switch-transition;

        $button-side-length: calc(#{$switch-button-height} - (2 * #{$switch-button-border-thickness}));

        cursor: pointer;

        .button {
            height: $button-side-length;
            width: $button-side-length;
            border: $switch-button-border-thickness solid $switch-button-color;
            border-radius: if($switch-is-rounded, $button-side-length, 0);
            background: $switch-button-color;

            transition: $switch-transition;
        }

        &.enabled {
            background-color: $switch-button-color;
            box-shadow: none;

            .button {
                background: white;
                transform: translateX(calc(#{$button-side-length} + (2 * #{$switch-button-border-thickness})));
            }
        }
    }

    .switch-button-label {
        margin-left: 10px;
        margin-right: 10px;
    }
}
</style>
